const { REACT_APP_CONTENTS_URL, REACT_APP_CONTENTS_TOKEN } = process.env;

const noticeListApi = () => {
  return {
    headers: {
      emquest_access_token: REACT_APP_CONTENTS_TOKEN,
    },
    apiUrl: REACT_APP_CONTENTS_URL + `/notice/list`,
  };
};

export default noticeListApi;
